import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslocoService } from '@ngneat/transloco';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {
  contentReady: boolean = false;
  isAr: boolean = false;
  currentLanguage: string | null = 'en';
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private transloco: TranslocoService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      const savedLang = localStorage.getItem('language') || 'en';

      this.currentLanguage = savedLang;
      this.isAr = savedLang === 'ar';

      this.transloco.setActiveLang(savedLang);
    }

    this.contentReady = true;
  }


}
